export const careTeamMemberRouteTemplates = {
  dashboardPage: '/',
  schedulePage: '/schedule',
  patientsPage: '/patients',
  patientRecordPage: '/patientRecord/:id',
  chatPage: '/chat',
  alertPage: '/alert',
  medicalTasksPage: '/medical-tasks',
  workspacesPage: '/workspaces',
  workspacesRecordPage: '/workspace/:id',
  analyticsPage: '/analytics',
  carePlansWorkspace_List: '/care-plans/workspace',
  carePlansTemplate_List: '/care-plans/templates',
  carePlanTemplate_One: '/care-plans/template/builder/:id',
  carePlanWorkspace_New: '/care-plans/workspace/builder/new',
  carePlanWorkspace_One: '/care-plans/workspace/builder/:id',
  careProgramBuilder_New: '/care-plans/workspace/care-program-builder/new',
  careProgramBuilder_Edit: '/care-plans/workspace/care-program-builder/:id',
  careProgramBuilder_View: '/care-plans/workspace/care-program-builder/view/:id',
  carePlanWorkspace_QuizCreationForNew:
    '/care-plans/workspace/builder/new/quiz-creation',
  carePlanWorkspace_QuizCreation:
    '/care-plans/workspace/builder/:id/quiz-creation',
  carePlanWorkspace_QuestionnaireCreationForNew:
    '/care-plans/workspace/builder/new/questionnaire-creation',
  carePlanWorkspace_QuestionnaireCreation:
    '/care-plans/workspace/builder/:id/questionnaire-creation',
  profileSettingsPage: '/profileSettings',
  templatesPage: '/templates',
  chartCreation: '/chartCreation',
  templatesPageQuestionnaireDetails: '/templates/questionnare/:id',
};

export const adminRouteTemplates = {
  dashboardPage: '/',
  settingsPage: '/settings',
  settingsUserPage: '/settings/user/:id',
  userSettingsPage: '/userSettings',
  subOrganizationPage: '/settings/subOrg/:id',
  careTeamPage: '/settings/careTeam/:id',
  subOrgPage: '/settings/subOrg/:id',
  profileSettingsPage: '/profileSettings',
  organizationPage: '/organization',
  patientGroupSetting: '/settings/patientGroup/:id',
  onCallGroupSetting: '/settings/onCallGroup/:id',
};

export const superAdminRouteTemplates = {
  settingsPage: '/',
};
